import { Routes, Route } from 'react-router-dom';
import { ThemeWrapper } from './theme/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import AppLayout from './components/layout/AppLayout';
import FloatingChatBot from './components/FloatingChatBot';
import TawkChatWidget from './components/TawkChatWidget';
import AuthPage from './pages/AuthPage';

import Dashboard from './pages/Dashboard';
import Strategy from './pages/StrategyPage';

import TradeFeedbackPage from './pages/TradeFeedbackRedesigned';
import CSVUploadPage from './pages/CSVUploadPage';
import ImageAnalysisPage from './pages/ImageAnalysisPage';
import AITradeCreate from './pages/AITradeCreate';
import PortfolioPage from './pages/PortfolioPage';
import TemplatesPage from './pages/TemplatesPage';

import TradeJournalPage from './pages/TradeJournalPage';
import CalendarPage from './pages/CalendarPage';

import StrategyPage from './pages/StrategyPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import WatchlistPage from './pages/WatchlistPage';


const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/*" element={<AuthPage />} />
      </Routes>
    );
  }

  return (
    <>
      <AppLayout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/strategy" element={<Strategy />} />
          <Route path="/portfolio" element={<PortfolioPage />} />

          <Route path="/ai-feedback" element={<TradeFeedbackPage />} />
          <Route path="/upload-csv" element={<CSVUploadPage />} />
          <Route path="/ImageAnalysisPage" element={<ImageAnalysisPage />} />
          <Route path="/ai-trade-create" element={<AITradeCreate />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/add-trade" element={<TradeJournalPage />} />

          <Route path="/TradeJournalPage" element={<TradeJournalPage />} />
          <Route path="/calendar" element={<CalendarPage />} />

          <Route path="/create-strategy" element={<StrategyPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/watchlist" element={<WatchlistPage />} />

        </Routes>
      </AppLayout>
      <FloatingChatBot />
    </>
  );
};

function App() {
  return (
    <ThemeWrapper>
      <SettingsProvider>
        <AuthProvider>
          <AppContent />
          <TawkChatWidget />
        </AuthProvider>
      </SettingsProvider>
    </ThemeWrapper>
  );
}

export default App;
